import React, { useState } from 'react';
import { CreateTrendlineStrategy } from '../components/Strategy';

// Add Icon
const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
  </svg>
);

/**
 * StrategyBuilderDemo - Demo page for testing the new strategy builder
 */
const StrategyBuilderDemo = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [createdStrategies, setCreatedStrategies] = useState([]);

  // Mock trend lines from chart (would come from TradingView integration)
  const mockTrendLines = [
    {
      id: 'tl-1',
      name: 'Support Line',
      x1: Date.now() - 30 * 24 * 60 * 60 * 1000, // 30 days ago
      y1: 2400,
      x2: Date.now(),
      y2: 2500,
    },
    {
      id: 'tl-2',
      name: 'Resistance Line',
      x1: Date.now() - 30 * 24 * 60 * 60 * 1000,
      y1: 2800,
      x2: Date.now(),
      y2: 2900,
    },
  ];

  const handleSuccess = (strategy) => {
    console.log('Strategy created:', strategy);
    setCreatedStrategies(prev => [...prev, strategy]);
    setDialogOpen(false);
  };

  return (
    <div className="container mx-auto max-w-6xl py-8 px-4">
      <h1 className="text-3xl font-bold mb-2">Strategy Builder Demo</h1>
      <p className="text-base-content/60 mb-6">
        Test the new TrendLine Strategy creation flow with rule groups
      </p>

      <div className="divider my-6"></div>

      <div className="tabs tabs-box mb-6 w-fit">
        <button 
          className={`tab ${tabValue === 0 ? 'tab-active' : ''}`}
          onClick={() => setTabValue(0)}
        >
          Modal Mode
        </button>
        <button 
          className={`tab ${tabValue === 1 ? 'tab-active' : ''}`}
          onClick={() => setTabValue(1)}
        >
          Inline Mode
        </button>
      </div>

      {/* Modal Mode */}
      {tabValue === 0 && (
        <div>
          <button
            className="btn btn-primary btn-lg gap-2"
            onClick={() => setDialogOpen(true)}
          >
            <AddIcon /> Create New Strategy
          </button>

          <CreateTrendlineStrategy
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            onSuccess={handleSuccess}
            availableTrendLines={mockTrendLines}
          />
        </div>
      )}

      {/* Inline Mode */}
      {tabValue === 1 && (
        <div className="card card-border bg-base-100 p-6">
          <CreateTrendlineStrategy
            inline
            onSuccess={handleSuccess}
            availableTrendLines={mockTrendLines}
          />
        </div>
      )}

      {/* Created Strategies List */}
      {createdStrategies.length > 0 && (
        <div className="mt-8">
          <h2 className="text-xl font-bold mb-4">
            Created Strategies ({createdStrategies.length})
          </h2>
          {createdStrategies.map((strategy, index) => (
            <div key={index} className="card card-border bg-base-100 p-4 mb-4">
              <h3 className="font-medium">{strategy.name}</h3>
              <p className="text-sm text-base-content/60">
                Ticker: {strategy.tickerName} | 
                Rule Groups: {strategy.ruleGroups?.length || 0}
              </p>
              <pre className="text-xs mt-2 overflow-auto bg-base-200 p-2 rounded">
                {JSON.stringify(strategy, null, 2)}
              </pre>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StrategyBuilderDemo;
